
import {
	FETCH_ORDER,
	FETCH_ORDER_SUCCESS,
	FETCH_ORDER_FAIL
} from "../constants/ActionTypes";

const initialState = {
	order: {},
	loading: false
};

export default function order(state = initialState, action) {
    switch (action.type) {
		case FETCH_ORDER:
            return {
				...state,
				order: {},
				loading: true
			};
        case FETCH_ORDER_SUCCESS:
            return {
				...state,
				order: action.order,
				loading: false
			};
		case FETCH_ORDER_FAIL:
            return {
				...state,
				error: action.error,
				loading: false
			};
        default:
            return state;
    }
}
